import { useContext, useMemo } from 'react';
import { Listing, STATUSES_TO_HIDE } from 'models/Listing';
import AuthContext from 'providers/Auth/Auth.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

export default function useShowEnquireAndWatchlist(listing: Listing) {
  const { isLoggedIn } = useContext(AuthContext);

  const { isListingEnquirableAndWatchableByMe } =
    useContext(CurrentUserContext);

  const [showEnquire, showWatchlist] = useMemo(() => {
    if (isLoggedIn) return isListingEnquirableAndWatchableByMe(listing);

    if (STATUSES_TO_HIDE.includes(listing?.stage)) return [false, false];

    return [true, false];
  }, [isLoggedIn, listing, isListingEnquirableAndWatchableByMe]);

  return { showEnquire, showWatchlist };
}
